module.exports = __webpack_public_path__ + "img/katarina_outside_11.a4f081b5.jpg";